import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import KollabPlayer from './KollabPlayer';
import type { KollabPlayerProps, KollabPlayerAPI, KollabPlayerHandle } from './types';

window.mountKollabPlayer = function mountKollabPlayer(
  containerId: string,
  props: KollabPlayerProps,
): KollabPlayerHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('KollabPlayer: container not found:', containerId);
    return { type: 'video', unmount: () => {}, get api() { return null; } };
  }

  // Determine media type from prop or element tag
  let mediaType: 'video' | 'audio' = 'video';
  if (props.mediaType) {
    mediaType = props.mediaType;
  } else if (props.mediaElementId) {
    const el = document.getElementById(props.mediaElementId);
    if (el && el.tagName === 'AUDIO') mediaType = 'audio';
  }

  const apiRef = createRef<KollabPlayerAPI>();
  const root = createRoot(container);
  root.render(React.createElement(KollabPlayer, { ...props, ref: apiRef }));

  return {
    type: mediaType,
    unmount: () => root.unmount(),
    get api() { return apiRef.current; },
  };
};
